import { Commande } from './../models/Commande.model';
import { Component, OnInit } from '@angular/core';
import { CommandeService } from '../_services/commande.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-listecommandeencours',
  templateUrl: './listecommandeencours.component.html',
  styleUrls: ['./listecommandeencours.component.css']
})
export class ListecommandeencoursComponent implements OnInit {

  constructor(private commandeservice: CommandeService) { }
  commandes: Commande[];
  p: number = 1;
  ngOnInit() {
    this.LoadAllCommandeEncours();
     ///////
     var pageHeader = $(".content-header").find("b");
     var adminForm = $(".admin-form");
     var buttons = adminForm.find(".button");
     var Panel = adminForm.find(".panel");
     setTimeout(function () {
       adminForm.addClass("theme-success");
       Panel.addClass("panel-success");
       pageHeader.addClass("text-success");

       buttons.removeClass().addClass("button btn-success");
     }, 800);
     //////
  }

  LoadAllCommandeEncours() {
    this.commandeservice.GetCommandeEncours().subscribe(
      (data: Commande[]) => {
        this.commandes = data;
        console.log(this.commandes);
      },
    );
  }

  UpadteEtatEnCours(id,data) {
      return this.commandeservice
        .updateEtatCommandeEncours(id)
        .subscribe(res => {
          console.log(res);
          this.AlertUpdate();
          this.LoadAllCommandeEncours();
        }, err => {
            console.log("Update non effectué");
        });
    }

  AlertUpdate() {
    Swal.fire({ title: 'Etat commande modifié avec succès' }).then(result => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }

  delete(id) {
    this.commandeservice.deleteData(id).subscribe(
      () => {
        this.LoadAllCommandeEncours();
      }
    )
  }

  deleteSupprimer(id) {
    Swal.fire({ title: 'Êtes-vous sûre de vouloir supprimer ?', showCancelButton: true }).then(result => {
      if (result.value) {
        this.delete(id);
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }
}
